import React from "react";
import { Box, Card, Typography, CardContent, CardMedia } from '@mui/material';
import Gallery from "./Gallery";
import About from "./About";
import Navbar from "./Navbar";
import VerticalTimeline from "./Timeline";

const Home = () => {
    return (
        <Box sx={{ width: "100%", backgroundColor: "white", height: "100%", justifyItems: "center" }}>
            <Box sx={{ width: "100%", backgroundColor: "#4cadd4", height: "20%", justifyItems: "center" }}>
                <Box sx={{ width: "100%", backgroundColor: "#f2f2f2", height: "100%", justifyItems: "left" }}>
                    <Box
                        component="img"
                        src="assets/images/tarunlogo.png" // Replace with your image URL
                        alt="home page image"
                        sx={{
                            maxWidth: { xs: "40%", md: "30%" }, // Full width on small screens, limited on larger
                            height: "100%", // Maintain aspect ratio
                            marginBottom: { xs: "0", md: "0" },
                        }}
                    />
                 
                </Box>
                <Navbar></Navbar>




            </Box>

            <Box sx={{ width: "100%", backgroundColor: "purple", height: "20%", textAlign: "center" }}>
            </Box>
{/* 
            <Box sx={{ width: "100%", backgroundColor: "white", height: "60%", textAlign: "center" }}>
                <Gallery></Gallery>
            </Box> */}






        </Box>


    );
};

export default Home;
